// eslint-disable-next-line import/prefer-default-export
export const REASON = 'reason';
